<template>
  <div class="settings-nji-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Nutritional Items</h5>
      <b-button
        class="pt-2 pb-2"
        variant="primary"
        size="sm"
        @click="addNutritionalJournalItem"
        >New</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="
        formId
          ? 'Edit Nutritional Journal Item'
          : 'Add Nutritional Journal Item'
      "
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitNutritionalJournalItem"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <template v-if="formId" v-slot:modal-header>
        <div class="w-100 d-flex flex-row justify-content-between">
          <h5 class="modal-title">Edit NutritionalJournalItem</h5>
          <div class="d-flex align-items-center">
            <button
              type="button"
              aria-label="Close"
              class="close text-white"
              @click="$refs['form-modal'].hide"
            >
              ×
            </button>
          </div>
        </div>
      </template>
      <b-form-group label="Categories">
        <b-form-select
          v-model="form.categoryId"
          :options="categories"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="Description">
        <b-form-input v-model="form.name" trim maxLength="100"></b-form-input>
      </b-form-group>

      <b-form-group label="Calories">
        <b-form-input v-model="form.calories" trim type="number"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import nutritionalJournalItemServer from "../../server/nutritionalJournalItem";
import { mapState, mapActions } from "vuex";

export default {
  name: "NutritionalItemCrud",
  components: {
    Grid
  },
  data() {
    return {
      list: [],
      formId: null,
      form: {
        calories: "",
        name: "",
        categoryId: ""
      },
      optionValue: ""
    };
  },
  mounted() {
    this.getNutritionalJournalItems();
    this.fetchRoles();
    this.fetchNutritionCategories();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("layout", ["fetchRoles"]),
    ...mapActions("client", [
      "fetchNutritionalJournalItems",
      "fetchNutritionCategories"
    ]),
    async getNutritionalJournalItems() {
      this.list = await nutritionalJournalItemServer.query();
    },
    async submitNutritionalJournalItem() {
      const formData = {
        ...this.form,
        calories: parseInt(this.form.calories)
      };
      if (this.formId) {
        await nutritionalJournalItemServer.update(this.formId, formData);
      } else {
        await nutritionalJournalItemServer.create(formData);
      }
      this.getNutritionalJournalItems();
      this.fetchNutritionalJournalItems();
      this.showAlertSuccess();
    },
    addNutritionalJournalItem() {
      this.formId = null;
      this.form = {
        calories: "",
        name: "",
        categoryId: ""
      };
      this.optionValue = "";
      this.$refs["form-modal"].show();
    }
  },
  computed: {
    ...mapState("layout", {
      roles: state =>
        state.roles.map(role => ({
          value: role.id,
          text: role.name
        }))
    }),
    ...mapState("client", {
      categories: state =>
        state.nutritionCategories.map(nutritionCategory => ({
          value: nutritionCategory.id,
          text: nutritionCategory.name
        }))
    }),
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      return [
        {
          text: "Description",
          field: "name",
          flex: 1,
          editor: false
        },
        {
          text: "Category",
          field: "category.name",
          flex: 1,
          editor: false,
          sortable(a, b) {
            return a.category.name.localeCompare(b.category.name);
          }
        },
        {
          text: "Calories",
          field: "calories",
          flex: 1,
          editor: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 110,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                const form = await nutritionalJournalItemServer.get(
                  this.formId
                );
                this.form = {
                  ...form,
                  categoryId: form.category.id
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await nutritionalJournalItemServer.delete(record.id);
                    this.getNutritionalJournalItems();
                    this.fetchNutritionalJournalItems();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
    }
  }
};
</script>

<style>
.settings-nji-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
